module.exports = __webpack_public_path__ + "static/media/right.836dbe3a.PNG";